const gclid = () => ({
    init() {
        const now = new Date()
        // if there is active gclid , do not set new one
        if (window.Alpine.store('gclid').gclid !== null && window.Alpine.store('gclid').utl !== null && now.getTime() < window.Alpine.store('gclid').utl) {
            return true
        }

        // expired entry , lets wipe it
        if (window.Alpine.store('gclid').gclid !== null && window.Alpine.store('gclid').utl !== null && now.getTime() >= window.Alpine.store('gclid').utl) {
            window.Alpine.store('gclid').gclid = null
            window.Alpine.store('gclid').utl = null
        }

        // get and store gclid if present in url
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('gclid') !== null) {
            // if there aint , create new one with 30 day TTL
            now.setDate(now.getDate() + parseInt(process.env.MIX_GCLID_DAYS_TO_PERSIST, 10))
            // for testing (comment above , uncomment below , this will allow you to see how store gets cleared or replaced
            // since isnetad of days you will be persisting for minutes)
            // now.setMinutes(now.getMinutes() + parseInt(process.env.MIX_GCLID_DAYS_TO_PERSIST, 10))
            window.Alpine.store('gclid').gclid = urlParams.get('gclid')
            window.Alpine.store('gclid').utl = now.getTime()
        }

        return true
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('gclid', gclid)
})
